export const pageResourceCenterEventsIndex = groq`*[_type == "resourceCenterEventsIndexPage" && currentPathname == $currentPathname][0]{
  ...,
  _id,
  _type,
  currentPathname,
  title,
  description,
  goToPage,
  showResults,
  clearAll,
  heroImage,
  heroNavigationCtaButtons,
}`;
